(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advent-info"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  if (customElements.get('advent-info-app')) return;

  function dispatchAdventEvent(root, name, detail) {
    root.dispatchEvent(
      new CustomEvent('advent:' + name, {
        bubbles: true,
        detail: detail || {}
      })
    );
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function normalize(value) {
    var str = String(value || '').toLowerCase();
    if (typeof str.normalize === 'function') {
      str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    return str;
  }

  class AdventInfoAppEl extends HTMLElement {
    constructor() {
      super();
      this.onSearchInput = this.onSearchInput.bind(this);
      this.onFlavourClick = this.onFlavourClick.bind(this);
      this.onModalClose = this.onModalClose.bind(this);
      this.onModalClick = this.onModalClick.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.lastTrigger = null;
    }

    connectedCallback() {
      this.section = this.closest('[data-section-id]') || this;
      this.searchInput = this.querySelector('[data-advent-search-input]');
      this.flavourListEl = this.querySelector('[data-advent-flavour-list]');
      this.flavourItems = Array.prototype.slice.call(
        this.querySelectorAll('[data-advent-flavour-item]')
      );
      this.flavourButtons = Array.prototype.slice.call(
        this.querySelectorAll('[data-advent-flavour-btn]')
      );
      this.noResultsEl = this.querySelector('[data-advent-no-results]');
      this.hintEl = this.querySelector('[data-advent-search-hint]');
      this.modal = this.querySelector('[data-advent-modal]');

      if (this.modal) {
        this.modalTitleEl = this.modal.querySelector('[data-advent-modal-title]');
        this.modalTypeEl = this.modal.querySelector('[data-advent-modal-type]');
        this.modalMediaEl = this.modal.querySelector('[data-advent-modal-media]');
        this.modalBodyEl = this.modal.querySelector('[data-advent-modal-body]');
        this.modalCloseBtn = this.modal.querySelector('[data-advent-modal-close]');
      }

      if (this.searchInput) {
        this.searchInput.addEventListener('input', this.onSearchInput);
      }

      this.flavourButtons.forEach(function (btn) {
        btn.addEventListener('click', this.onFlavourClick);
      }, this);

      if (this.modal) {
        this.modal.addEventListener('close', this.onModalClose);
        this.modal.addEventListener('click', this.onModalClick);
      }
      if (this.modalCloseBtn) {
        this.modalCloseBtn.addEventListener('click', this.onCloseClick);
      }

      this.filter('');
      this.applyInitialStateFromUrl();
    }

    disconnectedCallback() {
      if (this.searchInput) {
        this.searchInput.removeEventListener('input', this.onSearchInput);
      }
      this.flavourButtons.forEach(function (btn) {
        btn.removeEventListener('click', this.onFlavourClick);
      }, this);
      if (this.modal) {
        this.modal.removeEventListener('close', this.onModalClose);
        this.modal.removeEventListener('click', this.onModalClick);
      }
      if (this.modalCloseBtn) {
        this.modalCloseBtn.removeEventListener('click', this.onCloseClick);
      }
    }

    /* ---------------------------------------------------------------- */
    /* Zoeken / filteren                                                  */
    /* ---------------------------------------------------------------- */

    onSearchInput(event) {
      this.filter(event.target.value);
    }

    filter(query) {
      var normalizedQuery = normalize(query).trim();
      var hasQuery = normalizedQuery !== '';
      var visibleCount = 0;

      this.flavourItems.forEach(function (item) {
        var name = item.getAttribute('data-search-name') || '';
        var isMatch = hasQuery && name.indexOf(normalizedQuery) !== -1;
        item.hidden = !isMatch;
        if (isMatch) visibleCount += 1;
      });

      /* Vóór een zoekopdracht: alleen het zoekveld tonen, niet meteen alle
         smaken — dat verpest het overzicht van de rest van de pagina. */
      if (this.flavourListEl) {
        this.flavourListEl.hidden = !hasQuery || visibleCount === 0;
      }
      if (this.hintEl) {
        this.hintEl.hidden = hasQuery;
      }
      if (this.noResultsEl) {
        this.noResultsEl.hidden = !hasQuery || visibleCount !== 0;
      }

      dispatchAdventEvent(this.section, 'search', { query: query, results: visibleCount });
    }

    /* ---------------------------------------------------------------- */
    /* Smaak-detail + modal                                               */
    /* ---------------------------------------------------------------- */

    onFlavourClick(event) {
      var btn = event.currentTarget;
      var handle = btn.getAttribute('data-flavour');
      if (!handle) return;
      this.openFlavour(handle, btn, { updateUrl: true });
    }

    openFlavour(handle, triggerEl, options) {
      options = options || {};
      if (!this.modal || typeof this.modal.showModal !== 'function') return false;

      var dataEl = this.querySelector(
        '[data-advent-flavour-data][data-flavour="' + cssEscape(handle) + '"]'
      );
      if (!dataEl) return false;

      var contentEl = dataEl.querySelector('[data-advent-day-content]');
      var flavourName = dataEl.getAttribute('data-flavour-name') || '';
      var flavourType = dataEl.getAttribute('data-flavour-type') || '';
      var flavourImage = dataEl.getAttribute('data-flavour-image');
      var flavourImageAlt = dataEl.getAttribute('data-flavour-image-alt') || flavourName;

      if (this.modalTitleEl) {
        this.modalTitleEl.textContent = flavourName;
      }

      if (this.modalTypeEl) {
        if (flavourType) {
          this.modalTypeEl.textContent = flavourType;
          this.modalTypeEl.hidden = false;
          this.modalTypeEl.className =
            'advent-info-flavour__badge advent-info-flavour__badge--' +
            flavourType.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        } else {
          this.modalTypeEl.hidden = true;
        }
      }

      if (this.modalMediaEl) {
        if (flavourImage) {
          this.modalMediaEl.hidden = false;
          this.modalMediaEl.innerHTML =
            '<img src="' +
            flavourImage +
            '" alt="' +
            flavourImageAlt.replace(/"/g, '&quot;') +
            '" loading="lazy" width="700" height="700">';
        } else {
          this.modalMediaEl.hidden = true;
          this.modalMediaEl.innerHTML = '';
        }
      }

      if (this.modalBodyEl) {
        this.modalBodyEl.innerHTML = contentEl ? contentEl.innerHTML : '';
      }

      this.lastTrigger = triggerEl || null;

      if (options.updateUrl) {
        this.updateUrl(handle);
      }

      document.documentElement.classList.add('advent-info-lock-scroll');

      try {
        this.modal.showModal();
      } catch (err) {
        /* Dialog niet ondersteund of al open: negeer stilletjes */
      }

      dispatchAdventEvent(this.section, 'flavour_viewed', { flavour: handle });

      return true;
    }

    onCloseClick() {
      if (this.modal && typeof this.modal.close === 'function') {
        this.modal.close();
      }
    }

    onModalClick(event) {
      /* Klik op de ::backdrop laat de dialog zelf als event.target zien
         (klikken binnen .advent-info-modal__panel bubbelt vanaf een kind-element). */
      if (event.target === this.modal) {
        this.modal.close();
      }
    }

    onModalClose() {
      document.documentElement.classList.remove('advent-info-lock-scroll');
      if (this.lastTrigger && typeof this.lastTrigger.focus === 'function') {
        this.lastTrigger.focus();
      }
      this.lastTrigger = null;
    }

    /* ---------------------------------------------------------------- */
    /* URL query parameter (?smaak=)                                      */
    /* ---------------------------------------------------------------- */

    updateUrl(handle) {
      if (!window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        if (handle) {
          url.searchParams.set('smaak', handle);
        } else {
          url.searchParams.delete('smaak');
        }
        window.history.replaceState({}, '', url.toString());
      } catch (err) {
        /* Ongeldige URL-context (bv. sandboxed preview): negeer stilletjes */
      }
    }

    applyInitialStateFromUrl() {
      var params;
      try {
        params = new URL(window.location.href).searchParams;
      } catch (err) {
        return;
      }

      var flavourParam = params.get('smaak');
      if (!flavourParam) return;

      var matchingBtn = this.querySelector(
        '[data-advent-flavour-btn][data-flavour="' + cssEscape(flavourParam) + '"]'
      );
      if (!matchingBtn) return;

      this.openFlavour(flavourParam, matchingBtn, { updateUrl: false });
    }
  }

  customElements.define('advent-info-app', AdventInfoAppEl);
})();

  } catch(e) { console.error(e); }
})();
})();
